if (!customElements.get('hc-product-recommendations')) {
	customElements.define('hc-product-recommendations', class HcProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('hc-product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              
              // Reinitialize carousel after content loads
              const carouselInit = () => {
                const rail = this.querySelector('[data-hcfc-carousel]');
                if (!rail) return;
                const prev = this.querySelector('.hcfc__nav--prev');
                const next = this.querySelector('.hcfc__nav--next');

                const page = () => rail.clientWidth;

                function updateButtons() {
                  const maxScroll = rail.scrollWidth - rail.clientWidth - 1;
                  prev && (prev.disabled = rail.scrollLeft <= 0);
                  next && (next.disabled = rail.scrollLeft >= maxScroll);
                }
                function scrollByPage(dir) {
                  rail.scrollBy({ left: dir * page(), behavior: 'smooth' });
                }

                prev && prev.addEventListener('click', () => scrollByPage(-1));
                next && next.addEventListener('click', () => scrollByPage(1));
                rail.addEventListener('scroll', updateButtons, { passive: true });
                window.addEventListener('resize', updateButtons);
                updateButtons();
              };
              
              setTimeout(carouselInit, 0);
            }

            if (html.querySelector('.recommendation-list')) {
              this.classList.add('hc-product-recommendations--loaded');
            } else {
              this.classList.add('hidden');
            }
          })
          .catch(e => {
            console.error(e);
            this.classList.add('hidden');
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
}
